const PaymentTypeEnum = {
    DOMESTIC: 'DOMESTIC',
    INTERNATIONAL: 'INTERNATIONAL',
    PAYPAL: 'PAYPAL',
  }

  export default PaymentTypeEnum; 